import React from "react";
import { LinearProgress } from "@mui/material";
import { useTranslation } from "react-i18next";
import AutoCompleteBox from "components/Elements/EMIChip/AutoCompleteBox";

function TaskSearchFilters({
	searchText,
	setSearchText,
	chips,
	autocompleteData,
	isSearching,
	handleSelectSuggestion,
	customCaptions,
	classes,
}) {
	const { t } = useTranslation();
	return (
		<>
			{isSearching ? <LinearProgress className={classes.loading} /> : null}
			<AutoCompleteBox
				searchQuery={searchText}
				setSearchQuery={(e) => setSearchText(e.target.value)}
				label={t("label.searchEntity", { entity: customCaptions?.taskPlural ?? "Tasks" })}
				setSelectedValue={handleSelectSuggestion}
				dataSource={autocompleteData}
				isSearching={isSearching}
				chips={chips}
			/>
		</>
	);
}

export default TaskSearchFilters;
